import React from 'react';
import { Typography } from '@material-ui/core';
import cx from 'clsx';

interface AnnouncementPanelHeaderProps {
  title?: string;
  className?: string;
  children?: React.ReactNode;
}

export const AnnouncementPanelHeader = ({
  title,
  className,
  children
}: AnnouncementPanelHeaderProps) => {
  const content = title ? <Typography variant="h2">{title}</Typography> : children;

  return <header className={cx(className)}>{content}</header>;
};

export default AnnouncementPanelHeader;
